import React from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../context/ToastContext';
import './LanguageSelector.css';

const languages = [
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
];

function LanguageSelector({ compact = false }) {
  const { i18n, t } = useTranslation();
  const { showToast } = useToast();

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    const langName = languages.find(l => l.code === lng)?.name || lng;
    showToast(t('toast.languageChanged', { language: langName }), 'info');
  };

  if (compact) {
    return (
      <select
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="language-select language-select--compact"
        aria-label={t('language.select')}
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className="language-selector">
      <label className="language-label">{t('language.select')}</label>
      <select
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="language-select"
        aria-label={t('language.select')}
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LanguageSelector;
